import React__default, { useContext } from 'react';
import { L as LocalizationContext } from '../../chunks/bundle-BSUtC3cw.js';
import MessageInput from '../../ui/MessageInput.js';
import { u as useOpenChannelContext } from '../../chunks/bundle-C2pIFEfI.js';
import '../../chunks/bundle-j5GfJ6DZ.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../chunks/bundle-CnQtgeX8.js';
import '../../chunks/bundle-dyq0aH11.js';
import '../../chunks/bundle-CPQL3IZE.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../chunks/bundle-DRAooF75.js';
import 'dompurify';
import '../../chunks/bundle-CGAxlcUv.js';
import '../../chunks/bundle-xdZcjYxt.js';
import '../../chunks/bundle-DEv-umdP.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-idC_wVZi.js';
import '../../chunks/bundle-EMEHizdG.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bzoj1u3h.js';
import '../../chunks/bundle-Cj_4CfJM.js';
import '../../chunks/bundle-RVsnVYbw.js';
import '../../chunks/bundle-C6g3HNED.js';
import '../../chunks/bundle-CSKhnQl7.js';
import '../../chunks/bundle-DloqDvm2.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-S7XE7Lfi.js';
import '../../chunks/bundle-DwbhjuJz.js';
import '../../chunks/bundle-u2dy86rx.js';
import '../../chunks/bundle-B7LMd75S.js';
import '../../chunks/bundle-X0vBfD3T.js';
import '../../chunks/bundle-BlgLvEI8.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-B4W1Qw_4.js';
import 'react-dom';
import '../../chunks/bundle-DvCKSiBl.js';

var OpenChannelInput = React__default.forwardRef(function (props, ref) {
    var _a = useOpenChannelContext(), currentOpenChannel = _a.currentOpenChannel, disabled = _a.disabled, handleSendMessage = _a.handleSendMessage, handleFileUpload = _a.handleFileUpload, amIMuted = _a.amIMuted;
    var channel = currentOpenChannel;
    var stringSet = useContext(LocalizationContext).stringSet;
    var value = props.value;
    function getPlaceHolderString() {
        if (amIMuted) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED;
        }
        if (disabled) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
        }
        return '';
    }
    if (!channel) {
        return null;
    }
    return (React__default.createElement("div", { className: "sendbird-openchannel-footer" },
        React__default.createElement(MessageInput, { channel: currentOpenChannel, ref: ref, value: value, disabled: disabled, isVoiceMessageEnabled: false, onSendMessage: handleSendMessage, onFileUpload: handleFileUpload, placeholder: getPlaceHolderString() })));
});

export { OpenChannelInput as default };
//# sourceMappingURL=OpenChannelInput.js.map
